interface GoogleOAuthUrlParams {
  redirect_uri: string;
  client_id: string;
  access_type: string;
  response_type: string;
  prompt: string;
  scope: string | string[];
  state?: string;
}

export function buildGoogleOAuthURL(oauthUrl: string, options: GoogleOAuthUrlParams) {
  if (options.scope instanceof Array && options.scope.length) {
    options.scope = options.scope.join(' ');
  }

  const qs = new URLSearchParams(options as unknown as Record<string, string>);

  return `${oauthUrl}?${qs.toString()}`;
}
